import * as angular from "angular";
import {IController} from "angular";
import {ImportEntitiesService} from "../../services/import-entities.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import * as _ from "lodash";

export class ImportFileMappingComponent implements IController {
  entity: any;
  entityPath: string;
  onCancel: Function;
  onSubmit: Function;

  public preview: any;
  public file: any;
  public selectedSchema: any;
  public entityBringozFields: any[];
  public schemaFields: any;
  public section = 'upload';
  // public isAllowCreateSchema: boolean = false;
  public isSaveSchema: boolean = false;
  public validRows: any;
  public invalidRows: any;
  public summaryChartSegments: { value: number, color: string }[];
  public schemaOptionsWrapper: any;
  public isInvalidBringozFieldMapping: boolean;
  public entityRequiredBringozFields: any[];
  public isLoading: boolean;
  public schemas: any[] = [];
  public isSchemaEditMode: boolean;
  public isSchemaCreateMode: boolean;
  public isUpdateCurrentSchema: boolean;

  constructor(private importEntitiesService: ImportEntitiesService, private batchRequestsService: BatchRequestsService) {
  }

  $onInit() {
    this.getEntityBringozFields();
    this.getSchemasByEntity();
  }

  onSchemaFieldsChange(schemaFields) {
    this.schemaFields = angular.copy(schemaFields);
    // this.setIsAllowCreateSchema();
    this.isInvalidBringozFieldMapping = false;
  }

  onAddFile(file) {
    this.file = file;
  }

  onDeleteRow(row) {
    const rowIndex = this.preview.rows.findIndex(r => r.rowIndex === row.rowIndex);

    if (!this.preview.rows[rowIndex].valid) {
      const uploadRowIndex = this.invalidRows.findIndex(r => r.rowIndex === row.rowIndex);
      this.invalidRows.splice(uploadRowIndex, 1);
    } else {
      const uploadRowIndex = this.validRows.findIndex(r => r.rowIndex === row.rowIndex);
      this.validRows.splice(uploadRowIndex, 1);
    }

    const previewRowsCopy = angular.copy(this.preview.rows);
    previewRowsCopy.splice(rowIndex, 1);
    this.preview.rows = previewRowsCopy;

    this.setSummaryChartSegments();
  }

  onSelectSchema(schemaId, deleteSchemaId?: string, duplicateSchemaId?: string, reUpload?: boolean) {

    if (deleteSchemaId) {
      this.deleteSchema(deleteSchemaId);
    }


    if (!!duplicateSchemaId) {
      this.duplicateSchema(duplicateSchemaId);
    }


    if (this.selectedSchema?.id !== schemaId) {
      this.selectedSchema = angular.copy(this.schemas.find(s => s.id === schemaId));

      this.isSchemaEditMode = !this.selectedSchema;
      this.isSchemaCreateMode = false;

      if (reUpload) {
        this.onUploadFile();
      }
    }
  }

  private deleteSchema(schemaId: string) {
    this.batchRequestsService.deleteSchema(schemaId)
      .then(() => {
        const schemaIndex = this.schemas.findIndex(schema => schema.id === schemaId);

        this.schemas.splice(schemaIndex, 1);
        this.schemaOptionsWrapper = {
          list: this.schemas.map(s => {
            return {id: s.id, name: s.schemaName}
          }), propertyRef: 'name'
        };

        if (schemaId === this.selectedSchema?.id) {
          this.selectedSchema = undefined;
          this.onUploadFile();
        }
      });
  }


  private duplicateSchema(schemaId) {
    const schemaCopy = angular.copy(this.schemas.find(schema => schema.id === schemaId));

    schemaCopy.schemaName = schemaCopy.schemaName + ' Copy';
    _.unset(schemaCopy, 'id');

    this.batchRequestsService.createSchema(schemaCopy)
      .then((schema: any) => {
        this.schemas.push(schema);

        this.schemaOptionsWrapper = {
          list: this.schemas.map(s => {
            return {id: s.id, name: s.schemaName}
          }), propertyRef: 'name'
        };
      })
  }

  onUploadFile(isSchemaEditMode?: boolean) {
    if (this.file) {
      this.isLoading = true;
      this.importEntitiesService.getEntityImportPreview(this.entityPath, this.file, this.selectedSchema?.id)
        .then((response) => {
          if (isSchemaEditMode) {
            this.isSchemaEditMode = isSchemaEditMode;
          }

          this.preview = response;
          this.schemaFields = angular.copy(this.preview.customSchema.fields).sort(function (a, b) {
            return a.colIndex - b.colIndex;
          });
          this.section = 'mapping-preview';
        })
        .finally(() => {
          this.isLoading = false;
        })
    }
  };

  onToggleEditSchema() {
    this.isSchemaEditMode = true;
    this.isUpdateCurrentSchema = false;
  }

  onSubmitPreview(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {

        if (this.isUpdateCurrentSchema && !!this.selectedSchema?.id) {
          const schemaIndex = this.schemas.findIndex(s => s.id === this.selectedSchema?.id);
          const schemaCopy = angular.copy(this.selectedSchema);
          schemaCopy.fields = this.schemaFields.filter((f) => !!f.fieldType || !!f.defaultValue);

          this.batchRequestsService.editSchema(schemaCopy)
            .then((schema: any) => {
              this.schemas.splice(schemaIndex, 1, schema);

              this.schemaOptionsWrapper = {
                list: this.schemas.map(s => {
                  return {id: s.id, name: s.schemaName}
                }), propertyRef: 'name'
              };

              this.schemaFields = angular.copy(schema.fields);

            })
            .finally(() => {
              this.isSchemaEditMode = false;
            })
        }

        this.isInvalidBringozFieldMapping = this.entityRequiredBringozFields.findIndex(bf => {
          const schemaFieldIndex = this.schemaFields.findIndex(sf => sf.fieldType === bf.fieldType);
          return schemaFieldIndex === -1
        }) > -1;


        if (!this.isInvalidBringozFieldMapping) {
          const fields = this.schemaFields.filter((f) => !!f.fieldType || !!f.defaultValue);
          const schema = {
            schemaName: this.preview.customSchema.name,
            entityType: this.entity,
            fields: fields
          }

          this.isLoading = true;

          if (this.isSchemaCreateMode) {
            this.batchRequestsService.createSchema(schema)
              .then((schema: any) => {
                this.schemas.push(schema);
                this.schemaOptionsWrapper = {
                  list: this.schemas.map(s => {
                    return {id: s.id, name: s.schemaName}
                  }), propertyRef: 'name'
                };

                this.schemaFields = angular.copy(schema.fields);
                this.selectedSchema = schema;

              })
              .finally(() => {
                this.isSchemaCreateMode = false;
              })
          }

          const previewCopy = angular.copy(this.preview);
          previewCopy.customSchema.fields = this.schemaFields;

          this.preview = previewCopy;
          this.validateFileMapping();
        }

      }
    }
  }

  onUpload() {
    this.onSubmit({filePreview: this.preview});
  }

  onBack() {
    this.isSchemaEditMode = false;
    if (this.section === 'mapping-preview') {
      this.section = 'upload';
    }

    if (this.section === 'upload-preview') {
      this.section = 'mapping-preview';
    }

    if (this.section === 'summary') {
      this.section = 'mapping-preview';
    }

  }

  onChangePreviewRows(previewRows) {
    const previewCopy = angular.copy(this.preview);
    previewCopy.rows = previewRows;
    this.preview = previewCopy;
  }

  onToggleCreate() {
    this.isSchemaCreateMode = true;
  }

  validateFileMapping() {
    this.isLoading = true;

    const previewCopy = angular.copy(this.preview);
    _.unset(previewCopy.customSchema, 'id');
    this.importEntitiesService.getEntityImportValidation(this.entityPath, previewCopy, undefined)
      .then((res: any) => {
        this.preview = res;

        this.validRows = res.rows.filter(r => r.valid);
        this.invalidRows = res.rows.filter(r => !r.valid);
        this.setSummaryChartSegments();

        this.section = 'upload-preview';
        // this.isSchemaEditMode = false;
        // this.isSchemaCreateMode = false;

      })
      .finally(() => {
        this.isLoading = false;
      })
  }


  // private setIsAllowCreateSchema(): void {
  //
  //   this.isSchemaCreateMode = false;
  //   for (let i = 0; i < this.preview.customSchema.fields?.length; i++) {
  //     if (this.preview.customSchema.fields[i].fieldType !== this.schemaFields[i].fieldType) {
  //       this.isSchemaCreateMode = true;
  //       break;
  //     }
  //   }
  // }

  private getEntityBringozFields() {
    this.batchRequestsService.getSchemaDefaultFields(this.entity)
      .then((res: any[]) => {
        this.entityRequiredBringozFields = res.filter(item => item.required);
        this.entityBringozFields = res.sort((a, b) => {
          return (b.required ? 1 : 0) - (a.required ? 1 : 0);
        });
      });
  }

  private getSchemasByEntity() {
    this.batchRequestsService.getSchemas(this.entity)
      .then((schemas: any) => {
        this.schemas = schemas;
        this.schemaOptionsWrapper = {
          list: schemas.map(s => {
            return {id: s.id, name: s.schemaName}
          }), propertyRef: 'name'
        };
      })
  }

  private setSummaryChartSegments() {
    this.summaryChartSegments = [];
    const validChartSegment = {
      value: this.validRows.length,
      color: '#96D696'
    }

    const invalidChartSegment = {
      value: this.invalidRows.length,
      color: '#FF9C9D'
    }

    this.summaryChartSegments.push(validChartSegment);
    this.summaryChartSegments.push(invalidChartSegment);

  }
}

angular
  .module('bringoz.admin.commons')
  .component('importFileMapping', {
    bindings: {
      entity: '<',
      entityPath: '<',
      onCancel: '&',
      onSubmit: '&'
    },
    templateUrl: 'app/modules/commons/components/import-file-mapping/import-file-mapping.html',
    controller: ImportFileMappingComponent
  });
